import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import RadioButtonGroup from '../../../../../../components/RadioButtonGroup';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';

const FilterCriteria = (props) => {

  return (
    <div className="report-options mb-4">
      <span className="mb-4 fw-500 fs-5 pb-2 d-flex">Filter Criteria
        <OverlayTrigger
          key="image-overlay"
          placement="right"
          overlay={
            <Tooltip className="image-info-tooltip">
              <div>
                <p>{'a) Include (i.e. the assignment must have a least one question of that type.)'}</p>
                <p>{'b) Exclude (i.e. don\'t display any assignments with the question type.)'}</p>
                <p>{'c) May Contain (i.e. the assignment may or may not have questions of this type.)'}</p>
              </div>
            </Tooltip>
          }>
          <FontAwesomeIcon icon={faQuestionCircle} className="ms-2 clr-fa-circle-question fs-6 align-self-center cursor-pointer" />
        </OverlayTrigger>
      </span>

      <div className='d-flex gap-5'>
        <RadioButtonGroup groupName={'Multiple Choice'} inputName={'multipleChoice'} onChangeFunction={props.setMCValue} onChangeValue={props.mCValue} />
        <RadioButtonGroup groupName={'Fill-In'} inputName={'fillIn'} onChangeFunction={props.setFIValue} onChangeValue={props.fIValue} />
        <RadioButtonGroup groupName={'Constructed Response'} inputName={'constructedResponse'} onChangeFunction={props.setCRValue} onChangeValue={props.cRValue} />
      </div>
      {props.displayShowArchived && <div className="d-flex form-check gap-2 pt-3">
        <input
          id='showArchivedCheck'
          type="checkbox"
          className="form-check-input cursor-pointer"
          checked={props.showArchived}
          onChange={(e) => props.setShowArchived(e.target.checked)} />
        <p className='m-0'>Show Archived</p>
      </div>}
    </div>
  );
};

FilterCriteria.propTypes = {
  setMCValue: PropTypes.func,
  mCValue: PropTypes.number,
  setFIValue: PropTypes.func,
  fIValue: PropTypes.number,
  setCRValue: PropTypes.func,
  cRValue: PropTypes.number,
  displayShowArchived: PropTypes.bool,
  showArchived: PropTypes.bool,
  setShowArchived: PropTypes.func
};

export default FilterCriteria;
